__turbopack_context__.v({
  "callable": "ConstructorCardContent-module-scss-module__kW7S0W__callable",
  "exampleContent": "ConstructorCardContent-module-scss-module__kW7S0W__exampleContent",
  "exampleSection": "ConstructorCardContent-module-scss-module__kW7S0W__exampleSection",
  "exampleTitle": "ConstructorCardContent-module-scss-module__kW7S0W__exampleTitle",
  "method": "ConstructorCardContent-module-scss-module__kW7S0W__method",
  "parametersReturnsSection": "ConstructorCardContent-module-scss-module__kW7S0W__parametersReturnsSection",
  "returnsSection": "ConstructorCardContent-module-scss-module__kW7S0W__returnsSection",
  "signatureGrid": "ConstructorCardContent-module-scss-module__kW7S0W__signatureGrid",
});
